export enum DossierDeviceStatus {
    Queued = "Queued",
    CollectingRecordings = "CollectingRecordings",
    Ready = "Ready",
    Failed = "Failed",
}
